import React from "react";
import GlidePathDashboard from "./components/GlidePathDashboard";

function App() {
  return <GlidePathDashboard />;
}

export default App;
